/* eslint-disable no-nested-ternary */
import React, { forwardRef } from 'react';
import { Skeleton, Stack, Typography } from '@mui/material';

const AmountCard = forwardRef((props, ref) => {
    const { label, amount, loading = false, isAmount = true, sx, ...rest } = props;
    return (
        <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{
                // height: '100%',
                border: (theme) => `1px solid #ababab`,
                p: 2,
                borderRadius: 2,
                ...sx
            }}
            ref={ref}
            {...rest}
        >
            <Typography
                width="50%"
                variant="h6"
                sx={{
                    fontSize: '14px'
                }}
            >
                {label}
            </Typography>
            <Typography color="primary" variant="h4">
                {loading ? <Skeleton height={16} width={50} /> : isAmount ? `$ ${amount}` : amount}
            </Typography>
        </Stack>
    );
});

export default AmountCard;
